import React from 'react';

const Footer = () => {
  return (
    <footer
      className="font-sans"
      style={{ backgroundColor: '#0F2240' }}
      aria-label="Site footer"
    >
      {/* Gold top accent */}
      <div className="h-0.5 bg-school-gold w-full" />

      <div className="mx-auto max-w-7xl px-6 sm:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">

          {/* Logo & Contact */}
          <div className="md:col-span-2 space-y-6">
            <div className="flex flex-col gap-1">
              <span className="text-3xl font-heading font-bold text-white tracking-tight">PS 85</span>
              <span className="text-xs font-bold text-school-gold uppercase tracking-[0.2em]">The Great Expectations School</span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed max-w-sm">
              Fostering a community of excellence, innovation, and unwavering support for every student's journey.
            </p>
            <address className="not-italic text-sm space-y-2 border-l-2 border-school-gold/35 pl-4">
              <p className="text-white/80 font-medium">2400 Marion Avenue, Bronx, NY 10458</p>
              <p>
                <a
                  href="tel:+17185845275"
                  className="text-white/70 hover:text-school-gold transition-colors"
                >
                  (718) 584-5275
                </a>
              </p>
            </address>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xs font-bold text-school-gold uppercase tracking-[0.2em] mb-6">Quick Links</h3>
            <ul className="space-y-3 text-sm">
              {[
                { label: 'Staff Directory', href: '/coming-soon' },
                { label: 'Events Calendar', href: '/calendar' },
                { label: 'Latest News', href: '/coming-soon' },
                { label: 'Contact Us', href: '/contact' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/70 hover:text-school-gold hover:pl-1 transition-all duration-200 block"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Student Resources */}
          <div>
            <h3 className="text-xs font-bold text-school-gold uppercase tracking-[0.2em] mb-6">Student Resources</h3>
            <ul className="space-y-3 text-sm">
              {[
                { label: 'i-Ready Login', href: 'https://login.i-ready.com/' },
                { label: 'ClassDojo', href: 'https://www.classdojo.com/' },
                { label: 'TeachHub', href: 'https://teachhub.schools.nyc/' },
                { label: 'Tech Support', href: '/technology-resources' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/70 hover:text-school-gold hover:pl-1 transition-all duration-200 block"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/8 text-center text-xs text-white/60">
          <p>&copy; {new Date().getFullYear()} PS 85 The Great Expectations School. All rights reserved.</p>
        </div>

        {/* NexSav Credit */}
        <div className="mt-4 pt-4 border-t border-white/5">
          <a
            href="https://nexsav.net"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 text-white/60 hover:text-white/90 transition-all duration-300 group"
          >
            <img
              src="https://nexsav.net/static/media/logo.7ef8f9a8ca3ec946bd31.png"
              alt="NexSav Logo"
              className="h-5 opacity-60 group-hover:opacity-90 transition-opacity duration-300"
            />
            <span className="text-xs font-medium tracking-wide">
              Website designed &amp; developed by <span className="font-semibold">NexSav</span>
              <span className="sr-only"> (opens in new window)</span>
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
